"use client";
import { TrackCard } from "@/components/track-card";
import { PaginationWithLinks } from "@/components/ui/pagination-with-links";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useCollection } from "@/hooks/use-collection";
import { Genre, GetTracksQuery, Track } from "@/lib/generated/graphql";
import { memo, Suspense } from "react";
import { Aside } from "./aside";
import Filters from "./filters";
import { Section } from "./section";
import { SkeletonGrid, SkeletonSidebar } from "./skeletons";

type CollectionProps = {
  track: GetTracksQuery["getTracks"];
  genres: GetTracksQuery["getAllGenres"];
};
const SectionMemo = memo(Section);
const AsideMemo = memo(Aside);
const FiltersMemo = memo(Filters);
const TrackCardMemo =memo(TrackCard)
const PaginationWithLinksMemo = memo(PaginationWithLinks);

export const Collection = ({ track, genres }: CollectionProps) => {
  const {
    
    selectedGenre,
    debouncedSearchTerm,
    pagination,
    searchTerm,
    setSearchTerm,
    currentType,
    type,
    gridToggle,
    handleChangeGenre,
    handleChangeType,
  } = useCollection();

  return (
    <>
      <FiltersMemo
        page={pagination.pageIndex}
        type={type}
        genre={selectedGenre}
        query={debouncedSearchTerm}
      />
      <Tabs
        defaultValue={currentType}
        onValueChange={(value: string) => {
          handleChangeType(value);
          
        }}
      >
        <TabsList className="flex w-full justify-center gap-4 border-b border-border bg-muted p-2 rounded-t-lg">
          <TabsTrigger value="mixtape">Mixtapes</TabsTrigger>
          <TabsTrigger value="music">Musiques</TabsTrigger>
        </TabsList>

        {["music", "mixtape"].map((tab) => (
          <TabsContent
            key={tab}
            value={tab}
            className="flex flex-col md:flex-row min-h-[60vh]"
          >
            <Suspense fallback={<SkeletonSidebar />}>
              <AsideMemo
                genres={
                  genres?.filter((genre): genre is Genre => Boolean(genre)) ||
                  []
                }
                selectedGenre={selectedGenre}
                setSelectedGenre={handleChangeGenre}
              />
            </Suspense>

            <SectionMemo
              title={tab === "music" ? "Musiques" : "Mixtapes"}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              gridToggle={gridToggle}
            >
              <Suspense
                fallback={<SkeletonGrid isGrid={gridToggle?.isGrid ?? false} />}
              >
                <TrackCardMemo
                  tracks={(track?.content as Track[]) || []}
                />
                <div className="self-center mt-4">
                  <PaginationWithLinksMemo
                    page={pagination.pageIndex}
                    totalCount={track?.paginationMetadata?.totalItems ?? 0}
                    pageSize={pagination.pageSize}
                    pageSearchParam="page"
                  />
                </div>
              </Suspense>
            </SectionMemo>
          </TabsContent>
        ))}
      </Tabs>
    </>
  );
};
